import { Component, Input, Output, EventEmitter } from '@angular/core';
import { CookieService } from 'ngx-cookie-service';
import { getLanguageCookie } from 'src/assets/language';

@Component({
  selector: 'app-loading-instance',
  templateUrl: './loading-instance.component.html',
  styleUrls: ['./loading-instance.component.scss']
})
export class LoadingInstanceComponent {
  @Input() instance!: any;
  @Output() loadingComplete = new EventEmitter<void>();

  selectedFlag: any = {
    lang: 'en',
    file: 'us.svg'
  };

  constructor(
    private cookieService: CookieService,
  ) {}

  async ngOnInit() {
    setTimeout(() => {
      this.loadingComplete.emit();
    }, 1500);
  }

  getLanguages(file: string) {
    return getLanguageCookie(file, localStorage.getItem('language'))
  }

  getDisplayText(): string {
    const baseText = this.getLanguages('changeTo').trim();
    if (this.instance?.name) {
      return `${baseText} ${this.instance.name.trim()}`;
    } else if (this.instance?.label) {
      return `${baseText} ${this.instance.label.trim()}`;
    } else {
      return baseText;
    }
  }
}
